import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`padding:2rem;`;
const Back = styled.button`margin-bottom:1rem;`;

const Disclaimer: React.FC = () => {
  const nav = useNavigate();
  return (
    <Container>
      <Back onClick={() => nav('/dashboard')}>Back</Back>
      <h1>Disclaimer</h1>
      <p>Placeholder for disclaimer text.</p>
    </Container>
  );
};

export default Disclaimer;
